import type {
    EntityProfileMetaChip,
    EntityProfileSummaryField,
} from "~/components/entityProfile/types";
import type {EventContainerWithEvents} from "~/utilities/apis/api";
import {formatDateTime} from "~/utilities/utilities";

const SOURCE_FIELD_LABEL_HINTS = ["source", "channel", "platform"];

/** Created-at + source chips shown under the journey name (aside and mobile page). */
export function resolveJourneyProfileMetaChips(args: {
    journey: EventContainerWithEvents;
    summaryFields: Array<EntityProfileSummaryField>;
}): Array<EntityProfileMetaChip> {
    const chips: Array<EntityProfileMetaChip> = [];

    const createdAtLabel = formatDateTime(String(args.journey.createdAt));
    if (createdAtLabel !== "" && createdAtLabel !== "-") {
        chips.push({id: "createdAt", kind: "calendar", label: createdAtLabel});
    }

    const sourceField = args.summaryFields.find((field) => {
        const label = field.label.toLowerCase();
        return (
            SOURCE_FIELD_LABEL_HINTS.some((hint) => label.includes(hint)) &&
            field.value !== "" &&
            field.value !== "-"
        );
    });
    if (sourceField !== undefined) {
        chips.push({id: sourceField.id, kind: "tag", label: sourceField.value});
    }

    return chips;
}
